import React, { useEffect, useState }  from 'react';
import numeral from 'numeral';
import moment from 'moment';
import styled from 'styled-components';
import Spinner from 'react-spinner-material';
import DataTable from 'react-data-table-component-with-filter';

import PopoverHover from 'SharedComponents/popover-hover';
import ActionButton from 'SharedComponents/action-button';

import RaiseTransactionInquiryDialog from 'SharedComponents/dialog-raise-transaction-inquiry';
import RaiseTransactionInquiryForm from '../../components/form-raise-transaction-inquiry';

import CONFIG from 'Config';
import PopoverText from './PopoverText';

import styles from './TransactionsTable.css';

// define default format for numbers in numeral
numeral.defaultFormat('0,0.00');

// set default format for nulls
numeral.nullFormat('0.00');
numeral.zeroFormat('0.00');


  //<pre>{JSON.stringify(data, null, 2)}</pre>;


  const transactionStatus = (remittance_paid, transaction_status) => {
    console.log('calculating transactionStatus using');
    console.log('transaction_status : ', transaction_status);
    console.log('remittance_paid : ', remittance_paid);
  
    if (remittance_paid) {
      return 'Paid';
    }
  
    switch (transaction_status) {
      case 'approved':
      case 'maturing':
        return 'Clearing';
      case 'cleared':
        return 'Cleared';
      case 'void':
      case 'voided':
      case 'error':
      case 'rejected':
        return 'Void';
      default:
        return 'Pending';
    }
  };


const TransactionsTableWrapper = styled.div`${styles}`;

const TransactionsTableContributeNow = ({
  contributeNowTransactions, 
  //currentPage, 
  pageSize, 
  isFetchingTableData,
  showRaiseInquiryDialog,
  onShowRaiseInquiryDialog,
  //onCloseRaiseInquiryDialog,
  //onFetchCauseDonations,
  KeyOpenBankingTransactionStatusDescriptionsMap,
  //roundupsVisibility,
}) => {

  console.log('contributeNowTransactions in TransactionsTable is : ', contributeNowTransactions);
  console.log('typeof(contributeNowTransactions) is: ', typeof(contributeNowTransactions));
  console.log('showRaiseInquiryDialog in TransactionsTable status is : ', showRaiseInquiryDialog);
  console.log('props.onShowRaiseInquiryDialog in TransactionsTable status is : ', onShowRaiseInquiryDialog);

  //const [displayedTransactions, setDisplayedTransactions] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handlePageChange = (newPage, pageSize) => {
    console.log('handlePageChange in Transactions Table Triggered with newPage: ', newPage);
    //console.log('handlePageChange in Transactions Table Triggered with pageSize: ', pageSize);
    setPageNumber(newPage);
    //setRowsPerPage(rowsPerPage);
  }

  const handleChangeRowsPerPage = (currentRowsPerPage, currentPage) => {
    console.log('handleChangeRowsPerPage in Transactions Table Triggered with currentRowsPerPage: ', currentRowsPerPage);
    console.log('handleChangeRowsPerPage in Transactions Table Triggered with currentPage: ', currentPage);
    setRowsPerPage(currentRowsPerPage);
    setPageNumber(currentPage);
  }


  const timeToAllowRaiseInquiry = (affiliate_network_id) => {
    if (affiliate_network_id == 5 || affiliate_network_id == 13) {
      return 120 //6 days
    } else {
      return 24 // hours
    }
  }

  const ExpandedComponent = ({data}) => 
    
    (
      <div className="expander-row-container">
        <div className="transaction-details">
          <div className="transaction-item"> Date Time: <span style={{fontWeight:"bold"}}>&nbsp;{moment(data.created_at).local().format('DD MMM YYYY, h:mm:ss a')}</span></div>
          <div className="transaction-item"> Bank Reference: <span style={{fontWeight:"bold"}}>&nbsp;{data.party_bank_reference}</span></div>
          {/* <div className="transaction-item"> Boost To Super: <span style={{fontWeight:"bold"}}>&nbsp;{'$'+numeral(data.paymentData.payout.amount/100).format()}</span></div> */}
          <div className="transaction-item"> Boost To Super: <span style={{fontWeight:"bold"}}>&nbsp;{'$'+numeral(data.total_debit_amount/100).format()}</span></div>
          <div className="transaction-item"> Status: 
            <span style={{fontWeight:"bold"}}>&nbsp;{ 
            transactionStatus(data.remittance?.paid, data.status) //data.status
            }</span>
            {/* <span style={{fontWeight:"bold"}}>&nbsp;{transactionStatus (data.status,data.paid_charity)}</span> */}
              <span className="pop-over-container">
                <PopoverHover
                  content={
                    <div style={{
                      maxWidth: '300px', padding: 10, fontSize: '16px', fontWeight: 'bold', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', flexDirection: 'column', textAlign: 'left',
                    }}
                    >
                    {KeyOpenBankingTransactionStatusDescriptionsMap[ transactionStatus(data.remittance?.paid, data.status) ]}
                    </div>
                  }
                  header = {null}
                  img = {null}
                  itemToPopover = {
                    ( <i className="material-icons" style={{ margin: '0 5px 0 5px', verticalAlign: '-40%' }} >info</i> )
                  }
                  horizontalPosn = "right"
                />
              </span>
          </div>
          <div className="transaction-item"> Paid Date: <span style={{fontWeight:"bold"}}>&nbsp;
            {
                data.remittance?.paid
              ? moment(data.remittance?.payment_made_at).local().format('Do MMM YYYY')
              : ''
            }</span>
          </div>
          <div className="transaction-item"> Description: <span style={{fontWeight:"bold"}}>&nbsp;Contribute Now payment</span></div>

        </div>
      </div>
    );

  if (isFetchingTableData && !contributeNowTransactions.length) {
    return (
      <div style={{
        width: '100%', padding: 10, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: 80,
      }}
      >
        <Spinner spinnerColor="#000000" size={20} spinnerWidth={3} />
        <p>Fetching transactions</p>
      </div>
    );
  }

  if (!contributeNowTransactions.length) {
    return (
      <div style={{
        width: '100%', padding: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', height: 80,
      }}
      >
        <p>You currently have no Contribute Now transactions to display. Contribute Now transactions will appear on this table immediately after a successful contribution.</p>
      </div>
    );
  }

  const columns = [
    {
      name: '#',
      selector: (row,index) => ((index+1)+(pageNumber-1)*rowsPerPage),
      maxWidth: '60px',
      minWidth: 'unset',
    },
    {
      name: 'DATE',
      selector: row => moment(row.created_at).unix(),
      filterable: true,
      sortable: true,
      format: row => moment(row.created_at).format('Do MMM YYYY'),
    },
    {
      name: 'BANK REF',
      selector: row => row.party_bank_reference,
      filterable: true,
      sortable: true,
    },
    {
      name: 'BOOST TO SUPER',
      selector: row => numeral((row.total_debit_amount) / 100).format(), // Remove '$' here
      format: row => `$ ${numeral((row.total_debit_amount) / 100).format()}`, // Keep '$' in the formatted output
      filterable: true,
      sortable: true,
    },
    {
      name: 'PAID DATE',
      selector: row => 
        row.remittance?.paid
          ? moment(row.remittance?.payment_made_at).local().format('Do MMM YYYY')
          : '-',
      conditionalCellStyles: [
        {
          when: row => 
          !row.remittance?.paid,
          style: {color: 'white'},
        }
      ],
      filterable: true,
      sortable: true,
    },
    {
      name: 'STATUS',
      selector: row => {
         return transactionStatus(Boolean(row.remittance?.paid), row.status) //row.status,
      },
      // conditionalCellStyles: [
      //   {
      //     when: row => 
      //     !row.remittance?.paid,
      //     style: {backgroundColor: 'red', color: 'white', width: 'fitContent', padding: '3px 15px', borderRadius: '3px'},
      //   }
      // ],
      filterable: true,
      sortable: true,
    },

  ]


  return (
    <TransactionsTableWrapper>
        <DataTable
          columns={columns}
          pageSize={pageSize}
          data={contributeNowTransactions}
          highlightOnHover={true}
          responsive={true}
          customStyles={styles}
          defaultSortFieldId={2}
          defaultSortAsc={false}
          pagination
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          expandableRows
          expandableRowsComponent={ExpandedComponent}
          expandOnRowClicked={true}
        />  
    </TransactionsTableWrapper>
  );
};

export default TransactionsTableContributeNow;